export const LINKED_IN =
    "https://www.linkedin.com/in/mariia-tanchuk-4b72b3247/";

export const GITHUB = "https://github.com/Mariia-Kovalenko";
export const INSTA = "https://www.instagram.com/mariia_webcraft?igsh=MWhrejM1dHpoZzE3MQ%3D%3D&utm_source=qr";
export const STACK = [
    {
        id: "000",
        name: "React",
        image: "react.svg",
    },
    {
        id: "001",
        name: "NestJS",
        image: "nestjs.svg",
    },
    {
        id: "002",
        name: "Angular",
        image: "angular.svg",
    },
    {
        id: "003",
        name: "Sass",
        image: "sass.svg",
    },
    {
        id: "004",
        name: "Typescript",
        image: "typescript.svg",
    },
    {
        id: "005",
        name: "NodeJS",
        image: "nodejs.svg",
    },
    {
        id: "006",
        name: "NextJS",
        image: "NextJs.svg",
    },
    {
        id: "007",
        name: "Firebase",
        image: "Firebase.svg",
    },
    {
        id: "008",
        name: "MongoDB",
        image: "mongodb.svg",
    },
    {
        id: "009",
        name: "OpenAI",
        image: "openai.svg",
    },
    {
        id: "010",
        name: "NextJS",
        image: "NextJs.svg",
    },
    {
        id: "011",
        name: "GraphQL",
        image: "Graphql.svg",
    },
];

export const PROJECTS = [
    {
        id: 109,
        title: "Live Chat App",
        img: "chat.png",
        stack: [STACK[0], STACK[4], STACK[5]],
        text: `
        A real-time chat application allowing users join chat rooms, and exchange messages seamlessly. Currently, interaction can be tested by opening multiple browser windows.
        `,
        url: "https://chatapp-1-4qrx.onrender.com",
    },
    {
        id: 105,
        title: "Job Seeker",
        img: "job-seeker-home-light.png",
        stack: [STACK[0], STACK[8], STACK[5], STACK[11]],
        text: `
        A full-stack job search platform with a GraphQL backend, allowing users to easily find openings and where  employers can post and manage job positions.
        `,
        url: "https://job-seeker-v3au.onrender.com/",
    },
    {
        id: 100,
        title: "Glamo beauty app",
        img: "glamo.jpg",
        stack: [STACK[0], STACK[1], STACK[4], STACK[8]],
        text: `
        A full-stack web application for users who want to find beauty services available in the area and browse them on a map...
        `,
        url: "https://glamo-app-frontend.onrender.com/map",
    },
    {
        id: 101,
        title: "Brigantina Club Website",
        img: "brigantina.png",
        stack: [STACK[0], STACK[4], STACK[7]],
        img: "brigantina.png",
        text: `
        A commercial SPA website for a sporting organisation that features the main information about the club, its sections and news... 
        `,
        url: "https://brigantina-sports-club.com/",
        badges: ['commercial']
    },
    {
        id: 102,
        title: "Task manager",
        img: "tasks.jpg",
        stack: [STACK[2], STACK[5], STACK[8]],
        text: `
        A full stack Angular + NodeJS tasks management application that allows users to add tasks and manage their state ...
        `,
        url: "https://dashboard-angular-project.onrender.com",
    },
    {
        id: 103,
        title: "Find your cat",
        img: "find-your-cat.png",
        img: "find-your-cat.png",
        stack: [STACK[0]],
        text: `
        A front-end application that allows users to find cats by breed and view their information...
        A front-end application that allows users to find cats by breed and view their information...
        `,
        url: "https://cats-api-1am0.onrender.com",
    },
    {
        id: 104,
        title: "Currency converter",
        img: "currency-converter.png",
        img: "currency-converter.png",
        stack: [STACK[2], STACK[4]],
        text: `
       An Angular application to convert currencies USD, UAH and EUR according to the up-to-date currency course...
        `,
        url: "https://currency-converter-va9d.onrender.com",
    },
];

export const EXPERIENCE = [
    {
        id: "103",
        title: "React Front End Developer",
        company: "Levi9",
        years: "Feb 2026 - Present",
        text: `
        <ul>
          <li>💻 Developing the front-end of a standalone ad management application for a large media company</li>
          <li>🤖  Building UI components using React</li>
          <li>🤝 Collaborating with the design team to match layouts and functionality</li></ul>
        `,
    },
    {
        id: "101",
        title: "Shopify Front-End Developer",
        company: "Byteex",
        years: "2024 - 2025",
        text: `
        <ul>
          <li>🛒 Developed and maintained <b>custom Shopify eCommerce sites</b> for large-scale clients.</li>
          <li>🎨 Created themes from scratch and integrated <b>third-party apps</b>.</li>
          <li>📱 Optimized user experience with responsive, mobile-first designs.</li>
          <li>🔗 <b>Integrated external APIs</b> to enhance store functionality.</li> 
          <li>🤝 Collaborated with cross-functional teams to <b>meet business objectives</b> and deliver projects on time.</li>
        </ul>
        `,
    },
        {
        id: "102",
        title: "React + NodeJS Developer",
        company: "Freelance",
        years: "2022 - 2023",
        text: `
        <ul>
          <li>💻 Designed and developed a <b>custom SPA</b> for a sporting organization, managing the full development lifecycle.</li>
          <li>🎨 Created responsive UI/UX designs for seamless user experience across devices.</li>
          <li>🤝 Collaborated closely with the client to <b>deliver the project on schedule</b>.</li>
          <li>🤖 Built a <b>Node.js backend</b> for a Telegram bot to automate event registrations.</li>
          <li>🔔 Implemented <b>WebSockets</b> for real-time updates and automated user notifications.</li>
        </ul>
        `,
    },
    {
        id: "100",
        title: `Advanced Front-End Training Program`,
        company: "Epam Systems",
        years: "2022 - 2023",
        text: `
        <ul>
          <li>📚 Completed intensive training in modern front-end technologies <b>(React, Angular, Node.js, HTML5, CSS3, JavaScript)</b>.</li>
          <li>🔌 Gained hands-on experience with RESTful APIs, responsive design, and scalable front-end architectures.</li>
          <li>🏆 <b>Led a Hackathon project</b>, building a Waste-sorting application using React.</li>
        </ul>
        `,
    },
];

export const ACHIEVEMENTS = [
  {
    id: 1,
    image: 'travelling.jpg',
    text: 'Enjoy travelling',
    badgePosition: 'bottom-left',
    imageHeight: '100%'
  },
  {
    id: 2,
    image: 'athlete.jpg',
    text: 'Athlete',
    badgePosition: 'top-left',
    imageHeight: '50%'
  },
  {
    id: 3,
    image: 'coach.JPG',
    text: 'Former coach',
    badgePosition: 'bottom-left',
    imageHeight: '85%'
  },
  {
    id: 4,
    image: 'education.JPG',
    text: 'Awarded educator',
    badgePosition: 'bottom-right',
    imageHeight: '70%'
  },
  {
    id: 5,
    image: 'organiser.jpg',
    text: 'Event organizer',
    badgePosition: 'bottom-right',
    imageHeight: '90%'
  },
  {
    id: 6,
    image: 'content.jpg',
    text: 'Content creator',
    badgePosition: 'top-right',
    imageHeight: '90%'
  },

];
